import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import Buy6 from "./component/buy6";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [a4,sea4]=useState("None");
const [a5,sea5]=useState("None");
const [a6,sea6]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[bb4,setbb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[dir1,setdir1]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");
const[x20,setx20]=useState("None");
const[x11,setx11]=useState("None");
const[x12,setx12]=useState("None");
const[x13,setx13]=useState("None");
const[x14,setx14]=useState("None");
const[x15,setx15]=useState("None");
const[x16,setx16]=useState("None");
const[x17,setx17]=useState("None");
const[x18,setx18]=useState("None");
const[x19,setx19]=useState("None");
const[x21,setx21]=useState("None");
const[x22,setx22]=useState("None");
const[x23,setx23]=useState("None");
const[x24,setx24]=useState("None");
const[x25,setx25]=useState("None");
const[x26,setx26]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x4E3Fc4D4A93c3048f8CA5b2F54bD272dc38d95a9";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x1c4a6df76436e88b0D1AE1C432Ab047ec7a8D00B";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
     window.ethereum.on("chainChanged", (chainId) => {
  console.log("Chain changed:", chainId);
});

window.ethereum.on("accountsChanged", (accounts) => {
  if (accounts.length > 0) {
    setAccount(accounts);
  }
});
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          //0x105Dc8EE6ac8056FD40c58Bd387C68b1259E31D9
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      let alltasks1 = await contract.getMemos1(account[0]);
      setTasks1(alltasks1);
     
      var i = 0;
      
 const refer = (alltasks[1]);
      setrefer(refer);
      const refer4 = (alltasks[13]);
      setrefer4(refer4);
     
      

       const x21 = Number(alltasks[38]);
      setx21(x21);
      const x22 = Number(alltasks[30]);
      setx22(x22);
      const x23 = Number(alltasks[31]);
      setx23(x23);
      const x24 = Number(alltasks[32]);
      setx24(x24);
      const x25 = Number(alltasks[34]);
      setx25(x25);
  
      

document.querySelector("#a5").value  = Number(alltasks[0]);  
document.querySelector("#a6").value  =Number(alltasks1[1])/1000000000000;
  

      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const dir1 = Number(alltasks[22]);
     setdir1(dir1);
      const b =Number(alltasks[2]);
     
document.querySelector("#a7").value  = (alltasks[9]);
     document.querySelector("#hid").value  = (alltasks[1]);
     document.querySelector("#direct").value  = (alltasks[2]);
     document.querySelector("#level").value  = (alltasks[4]);
     document.querySelector("#wid").value  = (alltasks[32])/1000000000000000000;
     const direct =Number(alltasks[2]);
     setDirect(direct);
     
     const directs = Number(alltasks[24]);
      setDirects(directs);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[17])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

          

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[17])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[18])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	

const dd2 = Number(alltasks[22].toString());
setDD2(dd2);
				
	
      const reward4 =  Number(alltasks[23])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);


     const x1 = Number(alltasks[5]);
     setx1(x1);
     const x18 = Number(alltasks[20]);
     setx18(x18);
     const x19 = Number(alltasks[37]);
     setx19(x19);
          const x4 = Number(alltasks[24]);
     setx4(x4);
          const x5 = Number(alltasks[42]);
     setx5(x5);
     const x2 = Number(alltasks[25]);
     setx2(x2);
     const x3 = Number(alltasks[19]);
     setx3(x3);


     const x11 = (Number(alltasks[13])/1000000000000000000).toFixed(2);
     setx11(x11); 
     const x12 = Number(alltasks[14])/1000000000000000000;
     setx12(x12);
     const x13 = (Number(alltasks[15])/1000000000000000000).toFixed(2);
     setx13(x13);

     const x14 = (Number(alltasks[23])/1000000000000000000).toFixed(2);
     setx14(x14);


     const x15 = (Number(alltasks[7])/1000000000000000000).toFixed(2);
     setx15(x15);
     const x16 = Number(alltasks[36])/1000000000000000000;
     setx16(x16);
     const x17 = Number(alltasks[35])/1000000000000000000;
     setx17(x17);
    
    
     



     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

       
       const b1 = Number(alltasks[41]) ;
       setb1(b1);
       const b2 = Number(alltasks[42]) ;
       setb2(b2);
       const b3 = Number(alltasks[43]) ;
       setb3(b3);
       const b4 = Number(alltasks[44]) ;
       setb4(b4);

       const bb4 = Number(alltasks[20])/1000000000000000000 ;
       setbb4(bb4);


       const b5 = Number(alltasks[6]) ;
       setb5(b5);
       const b6 = Number(alltasks[26]) ;
       setb6(b6);
       const b7 = Number(alltasks[27]) ;
       setb7(b7);
       const b8 = Number(alltasks[28]) ;
       setb8(b8);
     const b9 = Number(alltasks[29]) ;
       setb9(b9);
	   
 const wlevel1 = Number(alltasks[11])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const wlevel = (Number(alltasks[12])/1000000000000000000 +  Number(alltasks[11])/1000000000000000000).toFixed(2);
          
 setLevelw(wlevel);

if(dd=='0x0E0f948847C028465707b72D15DD821b30935C8D')
{
  const wlevel1 = (Number(alltasks[11])/1000000000000000000)-100;
          
 setLevelw1(wlevel1);

 const wlevel = ((Number(alltasks[12])/1000000000000000000 +  Number(alltasks[11])/1000000000000000000).toFixed(2) - 100).toFixed(2);
          
 setLevelw(wlevel);
}

if(dd=='0xD17F67A90Ab4C02AdBA2eB13d25855E5aa45A2a8')
{
  const wlevel1 = (Number(alltasks[11])/1000000000000000000)-250;
          
 setLevelw1(wlevel1);

 const wlevel = ((Number(alltasks[12])/1000000000000000000 +  Number(alltasks[11])/1000000000000000000).toFixed(2) - 250).toFixed(2);
          
 setLevelw(wlevel);
}

 const level1 = Number(alltasks[21]);
          
 setLevel1(level1);
 

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
     const a3 = Number(alltasks1[1])/1000000000000000000;
          
     sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
  var a44 = 0;   
const pack1 = (pack + Number(alltasks[12])/1000000000000000000).toFixed(2);
setpackage1(pack1);
const pack3 = Number(alltasks[41])/1000000000000000000;
setpackage3(pack3);
     const tt =  (Number(alltasks[12])/1000000000000000000).toFixed(2);
     settt(tt);
     
     const a4 =  0 ;
     sea4(a4);

     const a5 =  0 ;
     sea5(a5);
     

     if(x25 == 1)
{
  const x26 =  "Silver" ;
setx26(x26);
}
if(x25 == 2)
{
  const x26 =  "Gold" ;
setx26(x26);
}
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://tetherworld.top/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;

     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);





        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

useEffect(() => {
    if (!dd2 || dd2 === "None") return;

    const updateTimer = () => {
        const now = Math.floor(Date.now() / 1000);

        const totalSeconds = Math.max(0, 86400 - (now - dd2));

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const time =
            String(hours).padStart(2, "0") + ":" +
            String(minutes).padStart(2, "0") + ":" +
            String(seconds).padStart(2, "0");

        settt2(time);

        const txt = document.querySelector("#tt2");
        if (txt) txt.value = time;

        if (totalSeconds <= 0) {
            clearInterval(timer);
        }
    };

    updateTimer();

    const timer = setInterval(updateTimer, 1000);

    return () => clearInterval(timer);

}, [dd2]); 

  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <input type="hidden" id ="direct"></input>
    <input type="hidden" id ="level"></input>
    <input type="hidden" id ="wid"></input>
    <input type="hidden" id ="a1"></input>
    <input type="hidden" id ="a2"></input>
    <input type="hidden" id ="a3"></input>
    <input type="hidden" id ="a4"></input>
    <input type="hidden" id ="a5"></input>
    <input type="hidden" id ="a6"></input>
    <input type="hidden" id ="a7"></input>
    
   <section className="dashboard-boxes-section" id="dashboard">
        <div className="container">
          <div className="dashboard-boxes-grid">

          
            <div className="dash-box-card">
  <div className="dash-box-title">
    ⚡ Quick Account Action
  </div>

{/* REGISTER BOX */}
<div
  style={{
    width: "100%",
    marginBottom: "16px",
    padding: "14px",
    background: "#111118",
    border: "1px solid #6b5315",
    borderRadius: "12px",
    boxSizing: "border-box",
  }}
>
  <label
    style={{
      display: "block",
      marginBottom: "8px",
      color: "#999",
      fontSize: "12px",
      fontWeight: 700,
    }}
  >
    Register
  </label>
<div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        alignItems: "center",
        width: "100%",
        minWidth: 0,
        gap: "8px",
      }}
    >
      <input
        type="text"
        id="testx"
        style={{
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          background: "#111118",
          border: "1px solid #6b5315",
          padding: "10px 14px",
          borderRadius: "12px",
          color: "#fff",
          outline: "none",
        }}
      />

  <div
    style={{
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: 0,
    }}
  >
    <Buy state={state} />
  </div>
</div>
    </div>

  {/* UPGRADE */}
 

  {/* WITHDRAW */}
  <div style={{ width: "100%", marginBottom: "16px" }}>
    <label
      style={{
        display: "block",
        marginBottom: "6px",
        color: "#999",
        fontSize: "12px",
        fontWeight: 700,
      }}
    >
      Withdraw
    </label>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        alignItems: "center",
        width: "100%",
        minWidth: 0,
        gap: "8px",
      }}
    >
      <input
        type="text"
        id="test"
        style={{
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          background: "#111118",
          border: "1px solid #6b5315",
          padding: "10px 14px",
          borderRadius: "12px",
          color: "#fff",
          outline: "none",
        }}
      />

      <div style={{ minWidth: 0, flexShrink: 0 }}>
        <Buy3 state={state} />
      </div>
    </div>
  </div>

   
 
</div>

{/* TRADE IN + TRADE BOX */}
<div
  style={{
    width: "100%",
    marginBottom: "16px",
    padding: "14px",
    background: "#111118",
    border: "1px solid #6b5315",
    borderRadius: "12px",
    boxSizing: "border-box",
  }}
>
  {/* TRADE IN */}
  <label
    style={{
      display: "block",
      marginBottom: "8px",
      color: "#999",
      fontSize: "12px",
      fontWeight: 700,
    }}
  >
    📥 Trade In
  </label>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: 0,
      marginBottom: "14px",
    }}
  >
    {tt2}
  </div>

  {/* TRADE */}
  <label
  className="dash-box-title"
    style={{
      display: "block",
      marginBottom: "8px",
      color: "#999",
      fontSize: "12px",
      fontWeight: 700,
    }}
  >
    📊 Trade
  </label>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: 0,
    }}
  >
    <Buy1 state={state} />
  </div>
</div>
<div
  style={{
    width: "100%",
    marginBottom: "16px",
    padding: "14px",
    background: "#111118",
    border: "1px solid #6b5315",
    borderRadius: "12px",
    boxSizing: "border-box",
  }}
>
<label
  className="dash-box-title"
    style={{
      display: "block",
      marginBottom: "8px",
      color: "#999",
      fontSize: "12px",
      fontWeight: 700,
    }}
  >
    📊 TWT Status
  </label>

   <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>TWT Price</span>
                  <span> {a3 } USDT</span>
                </div>
<br></br>
                 <div style={{ width: "100%", marginBottom: "16px" }}>
    <label
     
      style={{
        display: "block",
        marginBottom: "6px",
        color: "#999",
        fontSize: "12px",
        fontWeight: 700,
      }}
    >
      Buy Token
    </label>

    <div

      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        alignItems: "center",
        width: "100%",
        minWidth: 0,
        gap: "8px",
      }}
    >
      <input
        type="text"
        id="amt"
        style={{
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          background: "#111118",
          border: "1px solid #6b5315",
          padding: "10px 14px",
          borderRadius: "12px",
          color: "#fff",
          outline: "none",
        }}
      />

      <div style={{ minWidth: 0, flexShrink: 0 }}>
        <Buy2 state={state} />
      </div>
    </div>
  </div>
</div>

            <div className="dash-box-card">
              <div className="dash-box-title">
                🪙 Asset Values
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Total Deposit</span>
                  <span>{pack} USDT</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Asset Value</span>
                  <span> {pack1} USDT</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Pending Withdraw</span>
                  <span> {tt } USDT</span>
                </div>
              </div>
            </div>

            <div className="dash-box-card">
              <div className="dash-box-title">
                📈 Income
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Total Bonus</span>
                  <span>{wlevel }  USDT</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Total Withdraw</span>
                  <span> {wlevel1} USDT </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Trade Bonus</span>
                  <span>  {x11}  USDT</span>
                </div>
                  

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Direct Income</span>
                  <span>  {x12} USDT </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Level Income</span>
                  <span>  {x13} USDT </span>
                </div>
                 
              </div>
            </div>
             <div className="dash-box-card">
              <div className="dash-box-title">
                📈 Reward Eligble Directs
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Directs</span>
                  <span>{x21} </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Silver Directs</span>
                  <span> {x22} </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Gold Directs</span>
                  <span> {x23} </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Diamond Directs</span>
                  <span> {x24} </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Platinum Directs</span>
                  <span> 0</span>
                </div>
              </div>
            </div>

            <div className="dash-box-card">
              <div className="dash-box-title">
               📊 Royalty
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Silver Royalty</span>
                  <span>{x14}  USDT</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Gold Royalty</span>
                  <span> {x15} USDT </span>
                </div>

                
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Rewards</span>
                  <span>{x17} USDT  </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Salary</span>
                  <span> {x16 }  USDT</span>
                </div>


              </div>
            </div>

           
             <div className="dash-box-card">
              <div className="dash-box-title">
            🟡  Business
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>  Direct Business </span>
                  <span> {b5}</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Level II Business</span>
                  <span>  {b6} </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Level III Business</span>
                  <span> {b7} </span>
                </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Level IV Business</span>
                  <span>{b8}   </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Level V Business</span>
                  <span>   {b9}    </span>
                </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Total Business</span>
                  <span>  {plevel + b5}</span>
                </div>
                 


              </div>
            </div>
            <div className="dash-box-card">
              <div className="dash-box-title">
             💎 Active Team
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>  Direct Team </span>
                  <span>{directs}</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Level Team</span>
                  <span>  {level} </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Royalty Eligible Direct Team</span>
                  <span> {x3}   </span>
                </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Royalty Eligible Direct Business</span>
                  <span>{x2} USDT</span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Current Week A Team</span>
                  <span>  {x1}    </span>
                </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Current Week B Team</span>
                  <span>{x18} </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Current Week C Team</span>
                  <span>{x19}   </span>
                </div>
                 


              </div>
            </div>
             <div className="dash-box-card">
              <div className="dash-box-title">
             🔄  Ranks
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span> My Rank </span>
                  <span>{x26}</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Silver Direct</span>
                  <span> {b1}  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Gold Direct</span>
                  <span>   {b2}   </span>
                </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Diamond Direct</span>
                  <span> {b3} </span>
                </div>
                 <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Platinum Direct</span>
                  <span>   {b4}     </span>
                </div>
                  <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px",
                    background: "#111118",
                    borderRadius: "12px",
                  }}
                >
                  <span>Ruby Direct</span>
                  <span> 0</span>
                </div>
              
              </div>
            </div>
             

       <div className="dash-box-card">
  <div className="dash-box-title">
    🔗 Referral Link
  </div>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "15px",
    }}
  >
    <div
      style={{
        wordBreak: "break-all",
        flex: 1,
        minWidth: 0,
        background: "#111118",
        padding: "12px",
        borderRadius: "12px",
        color: "#f5c542",
        fontFamily: "monospace",
        fontSize: "0.8rem",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        border: "1px solid #6b5315",
      }}
    >
      {referlink}
    </div>

    <button
      type="button"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(referlink);
          alert("Referral link copied!");
        } catch (err) {
          console.error("Copy failed:", err);
        }
      }}
      style={{
        width: "42px",
        height: "42px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#111118",
        border: "1px solid #6b5315",
        borderRadius: "12px",
        cursor: "pointer",
        padding: "0",
        flexShrink: 0,
      }}
    >
      <img
        src="copy.png"
        width="15px"
        height="15px"
        alt="Copy"
      />
    </button>
  </div>
</div>

            <div className="dash-box-card">
              <div className="dash-box-title">
                💰  Sponsor  
              </div>

              <div
                style={{
                 
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "15px",
                }}
              >
                <div>
                  <span style={{ color: "#999", fontSize: "12px" }}>
                   My Sponsor
                  </span>

                  <div
                    style={{
                       fontSize:"0.8rem",
                  wordBreak:"break-all",
                    
                      fontWeight: 900,
                      color: "#f5c542",
                    }}
                  >
                      {refer} 
                  </div>
                </div>

              </div>
            </div>


           

          </div>
        </div>
      </section>


   

     

     
     
    <br></br>

   </div>

  );
}

export default App;